<template>
    <!-- 富文本 -->
    <div>
      <editor v-model="content" :init="init" :disabled="disabled" ></editor>
    </div>
  </template>
   
   
  <script>

  import tinymce from "tinymce/tinymce";
  import Editor from "@tinymce/tinymce-vue";
  import "tinymce/themes/silver";
  import "tinymce/plugins/image";
  import "tinymce/plugins/media";
  import "tinymce/plugins/table";
  import "tinymce/plugins/lists";
  import "tinymce/plugins/wordcount";
  import "tinymce/plugins/preview";
  import "tinymce/plugins/code";
  import "tinymce/plugins/link";
  import "tinymce/plugins/advlist";
  import "tinymce/plugins/codesample";
  import "tinymce/plugins/fullscreen";
  import "tinymce/plugins/searchreplace";
  import "tinymce/plugins/autolink";
  import "tinymce/plugins/directionality";
  import "tinymce/plugins/visualblocks";
  import "tinymce/plugins/visualchars";
  import "tinymce/plugins/template";
  import "tinymce/plugins/charmap";
  import "tinymce/plugins/nonbreaking";
  import "tinymce/plugins/insertdatetime";
  import "tinymce/plugins/autosave";
  import "tinymce/plugins/autoresize"; 
  import "tinymce/icons/default"; 
  import * as utils from "@/utils/httpUtils.js"
  import config from '@/config/index.js'
  import {getNowDate, getWeekday, getMonthAllDays,getJsMonthDayCh} from '@/utils/dateUtils.js'
  // import { EventBus } from "@/EventBus";

   
  export default {
    components: {
      Editor
    },
    props: {
      value: {
        type: String,
        default: ""
      },
      disabled: {
        type: Boolean,
        default: false
      },
      plus:{
        type: Boolean,
        default: true
      },
      plugins: {
        type: [String, Array],
        default:
          "preview searchreplace autolink directionality visualblocks visualchars fullscreen image link media template code codesample table charmap hr nonbreaking insertdatetime advlist lists wordcount  textpattern autosave autoresize code"
      },
      toolbar: {
        type: [String, Array],
        default:
          ` cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link codesample | alignleft aligncenter alignright alignjustify outdent indent formatpainter | preview code | 
          table image charmap hr pagebreak insertdatetime | 
          styleselect formatselect fontselect fontsizeselect |  
          myDateButton insertButton`
      }
      // toolbar1: {
      //   type: [String, Array],
      //   default:
      //     ` cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link codesample | alignleft aligncenter alignright alignjustify outdent indent formatpainter | preview code | 
      //     table image charmap hr pagebreak insertdatetime | 
      //     styleselect formatselect fontselect fontsizeselect |  
      //     myDateButton`
      // }
    },
    data() {
      return {
        //初始化配置

        init: {
          menubar: false, // 菜单栏显隐
          //language_url: "@/components/tinymce/langs/zh_CN.js",
          language_url: '../static/tinymce/langs/zh_CN.js', // vue-cli2.x
          language: "zh_CN",
          //skin_url: "@/components/tinymce/skins/ui/oxide",
          skin_url: '../static/tinymce/skins/ui/oxide', // vue-cli2.x
          content_css: 'src/assets/fonts/FZHei.css,src/assets/fonts/FZXBSJW.css',// vue-cli2.x
          height: 630,
          min_height: 630,
          max_height: 630,
          toolbar_mode: "wrap",
          plugins: this.plugins,
          toolbar: this.toolbar,// this.plus == true ? this.toolbar : this.toolbar1,
          pasteAsPlainText: true,
          content_style: "p {margin: 5px 0;} img {max-width:100%;}",
          fontsize_formats: "12px 14px 16px 18px 24px 36px 48px 56px 72px",
          font_formats:
            "微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif; \
             苹果苹方=PingFang SC,Microsoft YaHei,sans-serif; \
             宋体=simsun,serif; \
             仿宋体=FangSong,serif; \
             小标宋=FZXiaoBiaoSong; \
             楷体=KaiTi,sans-serif; \
             方正黑体=FZHei,sans-serif; \
             黑体=SimHei,sans-serif; \
             Arial=arial,helvetica,sans-serif; \
             Arial Black=arial black,avant garde; \
             Book Antiqua=book antiqua,palatino;",
          branding: false,
          paste_data_images: true,

          setup: function(editor) { 
            console.log("editor", editor);
            //editor.$emit("insertTest")
            editor.on('click', function(e) {
              // 获取点击的元素
              var targetNode = e.target;            
              // 在控制台输出点击的元素
              console.log(targetNode);
            
              // 你可以在这里添加更多的逻辑，比如根据点击的元素执行不同的操作
            });
          
            editor.ui.registry.addSplitButton('myDateButton', {
              text: '日期时间',
              onAction: (_) => editor.insertContent(getJsMonthDayCh(getNowDate()) + " " + getWeekday(getNowDate())),
              onItemAction: (buttonApi, value) => editor.insertContent(value),
              fetch: (callback) => {
                const items = [
                  {
                    type: 'choiceitem',
                    text: '当天 -月-日 周-',
                    value: getJsMonthDayCh(getNowDate()) + " " + getWeekday(getNowDate())
                  },
                  {
                    type: 'choiceitem',
                    text: '本月 -月-日 周-',
                    value: getMonthAllDays()
                  }
                ];
                callback(items);
              }
            });

    
            // editor.ui.registry.addMenuButton('insertButton', {
            // text: '插入',
            // fetch: (callback) => {
            //     const items = [
            //       {
            //         type: 'menuitem',
            //         text: '测试问题',
            //         onAction: (_) => EventBus.$emit("insertTest")
            //       },
            //       {
            //         type: 'menuitem',
            //         text: '试题',
            //         onAction: (_) => EventBus.$emit("insertQuestion")
            //       },
            //       {
            //         type: 'menuitem',
            //         text: '错题本',
            //         onAction: (_) => EventBus.$emit("insertErrorBook")
            //       },
            //       {
            //         type: 'menuitem',
            //         text: '调查问题',
            //         onAction: (_) => EventBus.$emit("insertDcwj")
            //       },

            //       {
            //         type: 'menuitem',
            //         text: '抽奖',
            //         onAction: (_) => EventBus.$emit("insertDraw")
            //       }
                  
            //     ];
            //     callback(items);
            //   }
            // });

            

          }, 

          


          

          // 粘贴图片后自动上传
          urlconverter_callback: function(url, node, on_save, name) {
            if (node === 'img' && url.startsWith('blob:')) {
              tinymce.activeEditor && tinymce.activeEditor.uploadImages()
            }
            return url;
          },
          // 图片上传
          images_upload_handler: (blobInfo, success, failure) => {
            // const img = 'data:image/jpeg;base64,' + blobInfo.base64()
            // success(img)
            const formData = new FormData()
            formData.append('file', blobInfo.blob())
            formData.append('biz', 'rich')
            let url = config.configData.api_url  + "/sys/common/uploadA";
            this.$showLoading();
            utils.httpFile(url,formData).then((res) => {
                console.log('===============',res.data);
                this.$closeLoading();
                let filePath = res.data.result.file;
                success(filePath);
            })
          }
        },
        content: this.value
      };
    },
    mounted() {
      tinymce.init({});
      console.log("2023-12-27====", getWeekday('2023-12-27'))
      console.log("2023-12-29====", getWeekday('2023-12-29'))
    },
    methods: {

                

    },
    watch: {
      value(newValue) {
        this.content = newValue;
      },
      content(newValue) {
        this.$emit("input", newValue);
      }
    }
  };
  </script>
  <style scoped >
  </style>
  
  


// WEBPACK FOOTER //
// src/components/richText/RichText.vue